import * as kea from 'node_modules/kea-react/dist/index';
import * as resources from "./usuario";
import { cacheResource, bindResource, observeResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { DateTime, cookies } from 'node_modules/kea-react/dist/index';


export const headerName = "Authorization";
function getUrlToken() {
    const prefix = "auth=";
    const hash = location.hash;
    const index = hash.indexOf(prefix);
    if (index == -1)
        return null;
    return decodeURIComponent(hash.substr(index + prefix.length));
}

/**Un token de autenticación de kea */
export interface KeaToken {
    token: string;
    original: string;
    idUsuario: number | null;
    idCliente: number | null;
    expira: Date;
    firma: string;
}

/**Parsea un token de autenticación. Devuelve null si el token es inválido*/
function parseToken(tokenOriginal: string): KeaToken | null {
    //Primero revisamos con el regex, si el regex no encaja, menos el base64
    const regex = /^KEA-SOFTWARE-TOKEN [A-Za-z0-9+/=]+$/;
    if (!regex.test(tokenOriginal)) {
        return null;
    }

    const prefix = "KEA-SOFTWARE-TOKEN ";
    const base64 = tokenOriginal.substr(prefix.length);

    try {
        const token = atob(base64);
        const split = token.split(";");

        //Revisamos que tenga 4 splits
        if (split.length != 4)
            return null;

        const idUsuario = split[0] ? Number.parseInt(split[0]) : null;
        const idCliente = split[1] ? Number.parseInt(split[1]) : null;
        const expira = new Date(Number.parseInt(split[2]) * 1000);
        const firma = split[3];

        if (idUsuario != null && Number.isNaN(idUsuario)) {
            return null;
        }

        if (idCliente != null && Number.isNaN(idCliente)) {
            return null;
        }

        const ret: KeaToken = {
            original: tokenOriginal,
            token: token,
            idUsuario: idUsuario,
            idCliente: idCliente,
            expira: expira,
            firma: firma
        };

        return ret;
    } catch (error) {
        return null;
    }
}

function getToken(): KeaToken | null {
    const urlToken = getUrlToken();
    if (urlToken) {
        kea.cookies.Set(headerName, urlToken);
    }
    const cookiesToken = kea.cookies.Get(headerName);
    if (typeof (cookiesToken) != "string") {
        return null;
    }
    return parseToken(cookiesToken);
}

/**Establece el token del usuario actual */
async function set(token: string | null) {
    kea.cookies.Set(headerName, token);
}

export const Session = cacheResource({ getUrlToken, getToken, set }, {
    getToken: true,
    getUrlToken: true
}, {
        set: true
    });




// WEBPACK FOOTER //
// ./app/resources/items/session.ts